import React, { useEffect, useState } from "react";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import Table from "../../../components/Table/Table";
import { columns } from "./constants";
import Notification from "../../../components/Notification";
import MultiToggleButtons from "../../../components/Button/MultiToggleButtons";
import ModalEncaminhamentos from "./ModalEncaminhamentos";
import {
  findAllEncaminhamentosModelo,
  saveEncaminhamento,
} from "../../../services/EncaminhamentoService";
import { withStyles } from "@material-ui/core";

const notificationDefault = {
  isOpen: false,
  message: "",
  variant: "",
};

export const pageableDTODefault = {
  pageSize: 15,
  sortField: "nome",
  sortDir: "ASC",
};

const tabs = {
  INFORMACOES: 0,
};

const Encaminhamentos = ({ classes }) => {
  const [notification, setNotification] = useState(notificationDefault);
  const [tabSelected, setTabSelected] = useState(tabs.INFORMACOES);
  const [pageableDto, setPageableDTO] = useState(pageableDTODefault);
  const [pageNumber, setPageNumber] = useState(0);
  const [last, setLast] = useState(true);
  const [encaminhamentos, setEncaminhamentos] = useState([]);
  const [encaminhamentoEdit, setEncaminhamentoEdit] = useState(null);
  const [openModalEncaminhamento, setOpenModalEncaminhamento] = useState(false);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [ativo, setAtivo] = useState({ label: "Ativo", value: true });

  useEffect(() => {
    loadAllEncaminhamentos({ resetValues: true });
  }, [ativo]);

  const loadAllEncaminhamentos = async ({ resetValues }) => {
    try {
      setIsLoading(true);

      const variables = {
        pageableDto: {
          ...pageableDto,
          pageNumber: resetValues ? 0 : pageNumber + 1,
        },
        search,
        ativo: ativo.value,
      };
      const { content, last } = await findAllEncaminhamentosModelo(variables);

      setLast(last);
      setEncaminhamentos(
        resetValues ? [...content] : [...encaminhamentos, ...content]
      );
      const page = resetValues ? 0 : pageNumber + 1;
      setPageNumber(page);
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Erro ao carregar Encaminhamentos!",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const closeAlertMessage = () => {
    setNotification(notificationDefault);
  };

  const showAlertMessage = (notification) => {
    setNotification(notification);
    setTimeout(() => {
      closeAlertMessage();
    }, 3000);
  };

  const handleFunction = async (event, fn) => {
    if (fn === "editar") {
      setEncaminhamentoEdit(event);
      setOpenModalEncaminhamento(true);
    } else {
      const variables = {
        encaminhamento: {
          ...event,
          ativo: !event.ativo,
        },
      };

      const response = await saveEncaminhamento(variables);
      if (response.id) {
        showAlertMessage({
          isOpen: true,
          message: "Salvo com sucesso",
          variant: "success",
        });
        loadAllEncaminhamentos({ resetValues: true });
      }
    }
  };

  const changeTab = (tab) => {
    setTabSelected(tab);
  };

  const handleChangeSearch = (e) => {
    const event = e?.target?.value ?? e;
    setSearch(event);
  };

  const handleSaveEncaminhamento = async (encaminhamento) => {
    try {
      const variables = {
        encaminhamento: {
          ...encaminhamento,
          ...(!encaminhamento.status && { ativo: true }),
        },
      };

      const response = await saveEncaminhamento(variables);
      if (response.id) {
        loadAllEncaminhamentos({ resetValues: true });
        showAlertMessage({
          isOpen: true,
          variant: "success",
          message: "Salvo!",
        });
        setOpenModalEncaminhamento(false);
      }
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Erro ao salvar!",
      });
      console.error(error);
    }
  };

  const handleClickNovoEncaminhamento = () => {
    setEncaminhamentoEdit({});
    setOpenModalEncaminhamento(true);
  };

  return (
    <div className={classes.container}>
      <HeaderConfiguracoesButtonNovo
        idPrefix="cfg-enc"
        title={"Encaminhamentos"}
        labelButton={"Novo encaminhamento"}
        search={{
          handleChange: handleChangeSearch,
          handleClickClear: () => handleChangeSearch(""),
          onClickButtonSearch: () =>
            loadAllEncaminhamentos({ resetValues: true }),
          value: search,
        }}
        handleClickNovo={() => handleClickNovoEncaminhamento()}
        showStatus
        status={{
          options: [
            { label: "Ativo", value: true },
            { label: "Inativo", value: false },
          ],
          value: ativo,
          onChange: (status) => setAtivo(status),
        }}
      />
      <div className={classes.content}>
        <MultiToggleButtons
          id="cfg-enc-btn-tab"
          tabSelected={tabSelected}
          changeTabSelected={(tab) => changeTab(tab)}
          disabled={true}
          posicaoDesabilitada={[1]}
          options={["Informações", "Auditoria"]}
          classes={{ buttonsContainer: classes.buttonsTab }}
        />
        {tabSelected === tabs.INFORMACOES && (
          <Scroll
            classes={{ root: classes.scroll }}
            hasMore={!last}
            loadMore={loadAllEncaminhamentos}
            pageStart={0}
            initialLoad={false}
          >
            <Table
              columns={columns({
                functions: {
                  handleEditar: (e) => handleFunction(e, "editar"),
                  handleAtivar: (e) => handleFunction(e, "ativar"),
                  handleDesativar: (e) => handleFunction(e, "desativar"),
                },
              })}
              dados={encaminhamentos || []}
              classes={{ table: classes.table }}
              isLoading={isLoading}
              emptyMessage={"Nenhum modelo de encaminhamento encontrado!"}
            />
          </Scroll>
        )}
      </div>
      {openModalEncaminhamento && (
        <ModalEncaminhamentos
          open={openModalEncaminhamento}
          handleClose={() => setOpenModalEncaminhamento(false)}
          encaminhamentoEdit={encaminhamentoEdit}
          handleSave={handleSaveEncaminhamento}
        />
      )}

      <Notification
        close={closeAlertMessage}
        reset={closeAlertMessage}
        isOpen={notification?.isOpen}
        variant={notification?.variant}
        message={notification?.message}
      ></Notification>
    </div>
  );
};

const styles = {
  container: {
    gap: "10px",
    height: "calc(100vh - 67px)",
    background: "f2f2f2",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    background: "#fff",
    borderRadius: "16px",
    padding: "0px",
    height: "100%",
    margin: "5px",
  },
  table: {
    "& thead tr :first-child": {
      borderRadius: "16px 0px 0px 0px",
    },
    "& thead tr :last-child": {
      borderRadius: "0px 16px 0px 0px",
    },
    "& tbody": {
      background: "#fff",
    },
  },
  buttonsTab: {
    margin: "8px 24px 0px",
  },
  scroll: {
    overflowY: "scroll",
    height: "calc(100% - 143px)",
  },
};

export default withStyles(styles)(Encaminhamentos);
